<template>
  <div class="folders-settings-container">
    <div v-if="depth === 0"
         class="folders-settings-headers"
    >
      <div></div>
      <div></div>
      <div class="acl-selector-box">
        Čtení
      </div>
      <div class="acl-selector-box">
        Zápis
      </div>
    </div>
    <div class="folders-settings-row">
      <!-- Tlacitko pro zapnuti a vypnuti editace -->
      <div class="asd-btn-group">
        <template v-if="value.name !== null">
          <button
            v-if="isEditing"
            v-help.mouse="'Ulozit nazev slozky'"
            class="asd-btn-confirm"
            @click="folderConfirmed()"
          >
            <i class="fas fa-save"></i>
          </button>
          <button
            v-else
            v-help.mouse="'Editovat nazev slozky'"
            class="asd-btn-edit"
            @click="isEditing = true"
          >
            <i class="fas fa-pencil-alt"></i>
          </button>
        </template>

        <button v-help.mouse="'Pridat podslozku'"
                class="asd-btn-action"
                @click="createSubFolder()"
        >
          <i class="fas fa-folder-plus"></i>
        </button>
        <ActiveButton
          v-if="depth > 0"
          class="asd-btn-delete"
          :click="removeFolder"
          :confirmText="`Opravdu chcete smazat slozku: ${value.name}?`"
        >
          <i class="fas fa-trash"></i>
        </ActiveButton>
      </div>
      <!-- Vypis nazvu slozky a jeji editace -->
      <div class="folder-name-box"
           :style="{ 'padding-left': `${10 + depth * 20}px` }"
      >
        <div v-if="value.name === null">
          <span style="font-weight: bold; color: darkred">Kořen složek</span>
        </div>
        <input
          v-else-if="isEditing"
          v-model="folderName"
          v-validate.initial
          class="asd-input"
          required="true"
          pattern="[\p{L}\. _-]+"
          @keypress.enter="folderConfirmed"
        />
        <div v-else>
          {{ value.name }}
        </div>
      </div>
      <!-- Prava pro cteni -->
      <div v-if="value.name !== null"
           class="acl-selector-box"
      >
        <Multiselect
          v-model="readValueHandler"
          valueByPath="id"
          label="label"
          :max="-1"
          :options="aclCategory"
          trackBy="id"
        >
        </Multiselect>
      </div>
      <!-- Prava pro zapis -->
      <div v-if="value.name !== null"
           class="acl-selector-box"
      >
        <Multiselect
          v-model="writeValueHandler"
          valueByPath="id"
          label="label"
          :max="-1"
          :options="aclCategory"
          trackBy="id"
        >
        </Multiselect>
      </div>
    </div>
    <!-- Rekursivne vypsane podslozky pokud jsou nejake -->
    <div v-for="f in children"
         :key="f.name"
    >
      <SambaFolders :value="f"
                    :depth="depth + 1"
                    @remove="handleRemove"
      ></SambaFolders>
    </div>
    <Modal v-if="showFolderHint">
      <template #default>
        Název složky je špatně vyplněn. Může obsahovat pouze následující znaky.
        <ul>
          <li>Čísla a písmena</li>
          <li>Mezera, podtržítko, pomlčka a tečka</li>
        </ul>
      </template>
      <template #controls>
        <button class="asd-btn-cancel"
                @click="showFolderHint = false"
        >
          Zavřít
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { get, filter, orderBy, has } from 'lodash'
// import TabbedView from 'CORE/components/tabbed-view/tabbed-view'
// import UISwitch from 'CORE/components/utilities/ui-switch'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import ActiveButton from 'CORE/components/form/active-button'
import Modal from 'CORE/components/modal/modal'

import { aclCategory } from 'ENUMS/files-acl-options'

export default {
    name: 'SambaFolders',
    components: {
        // TabbedView,
        Multiselect,
        ActiveButton,
        Modal,
    },
    props: {
        value: {
            required: true,
            type: Object,
        },
        depth: {
            required: false,
            type: Number,
            default: _ => 0,
        },
    },
    data() {
        return {
            isEditing: false,
            folderName: '',
            showFolderHint: false,
        }
    },
    computed: {
        aclCategory() {
            return aclCategory
        },
        readValueHandler: {
            set(value) {
                this.$set(this.value, 'read', value)
                this.$emit('input', this.value)
            },
            get() {
                return get(this.value, 'read', [])
            },
        },
        writeValueHandler: {
            set(value) {
                this.$set(this.value, 'write', value)
                this.$emit('input', this.value)
            },
            get() {
                return get(this.value, 'write', [])
            },
        },
        children() {
            return orderBy(get(this.value, 'children', []), ['name'], ['asc'])
        },
    },
    mounted() {
        this.folderName = get(this.value, 'name', '')
    },
    methods: {
        createSubFolder() {
            if (!has(this.value, 'children')) {
                this.$set(this.value, 'children', [])
            }
            console.info(this.value)
            this.value.children.push({ name: 'Nova_slozka', children: [] })
            this.$emit('input', this.value)
        },
        removeFolder() {
            this.$emit('remove', this.value)
        },
        handleRemove($event) {
            const filtered = filter(get(this.value, 'children', []), c => {
                return c.name !== $event.name
            })
            this.$set(this.value, 'children', filtered)
            this.$emit('remove', this.value)
        },
        folderConfirmed(e) {
            if (/^[^/]+$/.test(this.folderName)) {
                this.$set(this.value, 'name', this.folderName)
                this.$emit('input', this.value)
                this.isEditing = false
            } else {
                this.showFolderHint = true
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.folders-settings {
    &-container {
        display: flex;
        flex-direction: column;
        min-height: 40px;
    }
    &-row {
        display: flex;
        flex-direction: row;
        height: 40px;
        line-height: 40px;
        &:hover {
            background-color: rgba(178, 34, 34, 0.2);
        }
    }
}
.folders-settings-headers {
    display: flex;
    flex-direction: row;
    height: 2rem;
    & > :nth-child(2) {
        flex-grow: 1;
    }
    & > div {
        text-align: center;
        line-height: 2rem;
        font-weight: bold;
        color: var(--color-primary);
    }
}
.acl-selector-box {
    min-width: 400px;
}
.folder-name-box {
    flex-grow: 1;
}
</style>
